import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { FormFieldWrapper } from '../FormFieldWrapper';
import { ComboBox, ComboBoxChangeEvent, ComboBoxFilterChangeEvent } from '@progress/kendo-react-dropdowns';

interface FormComboBoxProps extends FieldRenderProps {
  isLoading?: boolean;
  onFilterChange?: (value: string) => void;
  onSelectionChange?: (value: any) => void;
}

export const FormComboBox: React.FC<FormComboBoxProps> = fieldRenderProps => {
  const { defaultValue, value, choices, name, disabled, isLoading, onFilterChange, onSelectionChange } =
    fieldRenderProps;

  if (!name) {
    return <></>;
  }

  const handleFilterChange = (event: ComboBoxFilterChangeEvent) => {
    if (onFilterChange) {
      onFilterChange(event.filter.value);
    }
  };

  const handleChange = (event: ComboBoxChangeEvent) => {
    if (onSelectionChange) {
      onSelectionChange(event.target.value);
    }
  };

  return (
    <FormFieldWrapper
      validationMessage={fieldRenderProps.validationMessage}
      value={fieldRenderProps.value}
      touched={fieldRenderProps.touched}
      id={fieldRenderProps.id}
      valid={fieldRenderProps.valid}
      disabled={fieldRenderProps.disabled}
      hint={fieldRenderProps.hint}
      label={fieldRenderProps.label}
      wrapperStyle={fieldRenderProps.wrapperStyle}
      optional={fieldRenderProps.optional}
      modified={fieldRenderProps.modified}
      visited={fieldRenderProps.visited}
      onChange={fieldRenderProps.onChange}
      onFocus={fieldRenderProps.onFocus}
      onBlur={fieldRenderProps.onBlur}
      name={fieldRenderProps.name}
      isLoading={isLoading}
    >
      <ComboBox
        data={choices || []}
        value={value || defaultValue || null}
        onChange={handleChange}
        onFilterChange={handleFilterChange}
        filterable={true}
        allowCustom={false}
        id={fieldRenderProps.name.toString()}
        validationMessage={fieldRenderProps.validationMessage || undefined}
        disabled={disabled}
      />
    </FormFieldWrapper>
  );
};
